import axios from 'axios';
import {
  EXERCISE_TEMPLATE_LIST_REQUEST, EXERCISE_TEMPLATE_LIST_SUCCESS, EXERCISE_TEMPLATE_LIST_FAIL,
  EXERCISE_TEMPLATE_CREATE_REQUEST, EXERCISE_TEMPLATE_CREATE_SUCCESS, EXERCISE_TEMPLATE_CREATE_FAIL,
  EXERCISE_TEMPLATE_UPDATE_REQUEST, EXERCISE_TEMPLATE_UPDATE_SUCCESS, EXERCISE_TEMPLATE_UPDATE_FAIL,
  EXERCISE_TEMPLATE_DELETE_REQUEST, EXERCISE_TEMPLATE_DELETE_SUCCESS, EXERCISE_TEMPLATE_DELETE_FAIL,
  EXERCISE_TEMPLATE_DETAILS_REQUEST,EXERCISE_TEMPLATE_DETAILS_SUCCESS,EXERCISE_TEMPLATE_DETAILS_FAIL,
  baseURL
} from './types';

const getAuthToken = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  return loginData.token || '';
};

// 1. Get All Templates
export const listExerciseTemplates = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: EXERCISE_TEMPLATE_LIST_REQUEST });
    const config = {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getAuthToken()}` }
    };
    const { data } = await axios.post(`${baseURL}/api/appointementExerciseTemplate/getall`, filters, config);
    dispatch({ type: EXERCISE_TEMPLATE_LIST_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: EXERCISE_TEMPLATE_LIST_FAIL, payload: error.response?.data?.message || error.message });
  }
};

// 2. Create Template
export const createExerciseTemplate = (templateData) => async (dispatch) => {
  try {
    dispatch({ type: EXERCISE_TEMPLATE_CREATE_REQUEST });
    const config = {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getAuthToken()}` }
    };
    const { data } = await axios.post(`${baseURL}/api/appointementExerciseTemplate/create`, templateData, config);
    dispatch({ type: EXERCISE_TEMPLATE_CREATE_SUCCESS, payload: data });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: EXERCISE_TEMPLATE_CREATE_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};

// 3. Update Template
export const updateExerciseTemplate = (templateData) => async (dispatch) => {
  try {
    dispatch({ type: EXERCISE_TEMPLATE_UPDATE_REQUEST });
    const config = {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getAuthToken()}` }
    };
    const { data } = await axios.patch(`${baseURL}/api/appointementExerciseTemplate/update`, templateData, config);
    dispatch({ type: EXERCISE_TEMPLATE_UPDATE_SUCCESS, payload: data });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: EXERCISE_TEMPLATE_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};

// 4. Delete Template
export const deleteExerciseTemplate = (id) => async (dispatch) => {
  try {
    dispatch({ type: EXERCISE_TEMPLATE_DELETE_REQUEST });
    const config = {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getAuthToken()}` },
      data: { id: id }
    };
    const { data } = await axios.delete(`${baseURL}/api/appointementExerciseTemplate/delete`, config);
    dispatch({ type: EXERCISE_TEMPLATE_DELETE_SUCCESS, payload: id });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: EXERCISE_TEMPLATE_DELETE_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};
// 5. Get Single Template by ID
// export const getExerciseTemplateById = (id) => async (dispatch) => {
//   try {
//     dispatch({ type: EXERCISE_TEMPLATE_DETAILS_REQUEST });

//     const config = {
//       headers: { 
//         'Content-Type': 'application/json', 
//         'Authorization': `Bearer ${getAuthToken()}` 
//       }
//     };


//     const { data } = await axios.post(`${baseURL}/api/appointementExerciseTemplate/byid`, { id }, config);

//     dispatch({ 
//       type: EXERCISE_TEMPLATE_DETAILS_SUCCESS, 
//       payload: data.data[0] 
//     });
//   } catch (error) {
//     dispatch({ 
//       type: EXERCISE_TEMPLATE_DETAILS_FAIL, 
//       payload: error.response?.data?.message || error.message 
//     });
//   }
// };
// exerciseTemplateAction.js ke andar
// exerciseTemplateAction.js

export const getExerciseTemplateById = (id) => async (dispatch) => {
  try {
    dispatch({ type: EXERCISE_TEMPLATE_DETAILS_REQUEST });

    const config = {
      headers: { 
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${getAuthToken()}` 
      }
    };

    // Aapka sahi URL aur POST method
    const { data } = await axios.post(`${baseURL}/api/appointementExerciseTemplate/byid`, { id }, config);

    console.log("API Response Data:", data); // Debugging ke liye

    if (data.success) {
      dispatch({ 
        type: EXERCISE_TEMPLATE_DETAILS_SUCCESS, 
        payload: data.data // Agar data structure {success:1, data: {...}} hai
      });
    }
  } catch (error) {
    console.error("Action Error:", error);
    dispatch({ 
      type: EXERCISE_TEMPLATE_DETAILS_FAIL, 
      payload: error.response?.data?.message || error.message 
    });
  }
};